<template>
	<div id="app" v-cloak>
		<div class="header">
		   <el-date-picker
		     v-model="times"
		     type="daterange"
		     value-format="yyyy-MM-dd"
		     range-separator="至"
			 @change="getData"
			 size="mini"
		     style="vertical-align: middle;margin-top: -1px;"
		     start-placeholder="开始日期"
		     end-placeholder="结束日期">
		   </el-date-picker>
		</div>

	   <el-table
	    :data="tableData"
	    border
	    style="width: 100%;text-align: center;">
	    <el-table-column
		  header-align="center"
	      prop="username"
	      label="员工姓名">
	    </el-table-column>
		<el-table-column
		  header-align="center"
		  prop="dao_count"
		  label="已到访">
		</el-table-column>
	    <el-table-column
		  header-align="center"
		  prop="dao_no"
	      label="未到访">
	    </el-table-column>
	    <el-table-column
		  header-align="center"
	      label="到访率">
		   <template slot-scope="scope">{{scope.row.dao_rate}}%</template>
	    </el-table-column>
	  </el-table>

	  <el-pagination
		  @current-change="getData"
		  background
		  :page-size="10"
		  prev-text="上一页"
		  next-text="下一页"
		  style="margin-top: 10px;"
		  :total="page_data.count">
	  </el-pagination>
	</div>
</template>

<script>
	 export default {
	    data() {
	      return {
            token:'',
			page_data:0,
			tableData:[],
			times:'',
			start_time:'',
			end_time:'',
			currentPage:1,
	      }
	    },
	    mounted(){
            this.token = this.$cookies.get('token')

			this.getData()
	    },
	    methods:{
	    	//表格数据
	    	getData(val){
				if(Array.isArray(val)){
					this.start_time = this.times[0]
					this.end_time = this.times[1]
				} else if(typeof(val) == 'number'){
					this.currentPage = val
				}

	    		let self = this
	    		$.ajax({
					  url: process.env.apiUrl +'saas/qk/visit',
					  type: 'post',
					  data:{
					  	  token:self.token,
						  page:self.currentPage,
						  start_time:self.start_time,
						  end_time:self.end_time,
					  },
					  success: function (res) {
                          if(res.status == 1){
                              self.tableData = res.data
							  self.page_data = res.map
                          } else{
                              self.tableData = []
							  self.page_data = 0
                          }
					  },
					  error: function (err) {
					     console.log(err.status)
					  }
				})
	    	},
	     },
	  };
</script>

<style scoped="scoped">
	#app{
		margin: 0 10px;
	}
	 .header{
		 margin-top: 18px;
		 margin-bottom: 10px;
	 }
</style>



// WEBPACK FOOTER //
// src/pages/genjin/fenxi.vue